import {
  Header,
  SpaceBetween,
} from '@cloudscape-design/components';
import { formatDuration } from 'features/plc/components/common';
import PLCButton from 'features/plc/components/PLCButton';
import { PLC_PATHS, PRESS_MODE } from 'features/plc/contracts/pressHMI.schema';
import { usePLCValue, usePressTitle } from 'features/plc/providers/PLCProvider';
import PropTypes from 'prop-types';
import React from 'react';

export default function PressHMIHeader({ cycleStatePath, cycleStateLabels, disableLabel }) {
  const pressTitle = usePressTitle();
  const cycleRunning = usePLCValue(PLC_PATHS.status.cycleRunning);
  const cycleState = usePLCValue(cycleStatePath);
  const cycleElapsed = usePLCValue(PLC_PATHS.status.cycleElapsed);
  const stateElapsed = usePLCValue(PLC_PATHS.status.stateElapsed);
  const stateRemaining = usePLCValue(PLC_PATHS.status.stateRemaining);
  const stageLabel = cycleRunning
    ? (cycleStateLabels[cycleState] || `Unknown Stage (${cycleState ?? '--'})`)
    : 'Automation Disabled';
  const elapsedDescription = `Automation duration: ${formatDuration(cycleElapsed)} | Stage duration: ${formatDuration(stateElapsed)}`;

  return (
    <Header
      variant="h1"
      description={elapsedDescription}
      actions={(
        <SpaceBetween direction="horizontal" size="xs">
          <PLCButton
            path={PLC_PATHS.cmd.pressMode}
            value={PRESS_MODE.NONE}
            variant="primary"
          >
            {disableLabel}
          </PLCButton>
        </SpaceBetween>
      )}
    >
      {[pressTitle, stageLabel, stateRemaining > 0 ? formatDuration(stateRemaining) : null].filter(Boolean).join(' - ')}
    </Header>
  );
}

PressHMIHeader.propTypes = {
  cycleStatePath: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  cycleStateLabels: PropTypes.objectOf(PropTypes.string).isRequired,
  disableLabel: PropTypes.string.isRequired,
};
